import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getNotifications,
    createNotification,
    updateNotification,
    deleteNotification
}

function getNotifications(userId) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/notifications`)
           .set('access', Storage.getItem('access'))
           .query({userId})
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function createNotification(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/notifications`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateNotification(notificationId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/notifications/${notificationId}`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function deleteNotification(notificationId) {
    return new Promise((resolve, reject) => {
        Superagent
           .delete(`${HOST_API}/notifications/${notificationId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}